
import useStartPage from "./useStartPage";
import {BASE_URL} from "../../../config/config";
import FillVatPopup from "../../../elements/fillVatPopup/FillVatPopup";
import '../../../assets/wcs_static/kick_start_your_business_project/assets/toolkit/styles/wcs-custom.css';
// import KsybContent from "../../../elements/ksybContent";

const StartPage = () => {
    const {taxId,
        setTaxId,
        checkTaxId,
        togglePopup,
        errorInput,
        visible,
        eligible,
        style,
        translations,
        clicked,
        visiblePopup,
        getHeight,
        refs,
        toggle,
        openStates,
        lang,
        errorMessage1,
        hidePopup,
        changeInput,
        errorMessage2,htmlObject,containerRef,tries,checkInput,isKsybError
    } = useStartPage();


    return(
        <>

            <div  dangerouslySetInnerHTML={{ __html: htmlObject}} ref={containerRef} />
            {
                !hidePopup &&
                <FillVatPopup show={visible}
                              onInput={changeInput}
                              onClick={checkTaxId}
                              onHide={togglePopup}
                              errorInput={errorInput}
                              taxId={taxId}
                              eligible={eligible}
                              styles={style}
                              translations={translations}
                              visible={visiblePopup}
                              clicked={clicked}
                              lang={lang}
                              message1={errorMessage1}
                              message2={errorMessage2}
                              tries = {tries}
                              checkInput = {checkInput}
                              isKsybError={isKsybError}
                />
            }

        </>
    )
}
export default StartPage;
